var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteiconsSvg15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 51,
    viewBox: "0 0 35 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2620_1417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2225 28.2278C23.31 28.2278 28.2449 23.2929 28.2449 17.2054C28.2449 11.118 23.31 6.18311 17.2225 6.18311C11.1351 6.18311 6.2002 11.118 6.2002 17.2054C6.2002 23.2929 11.1351 28.2278 17.2225 28.2278Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9027 16.987C32.9027 24.5597 20.9129 41.342 17.9016 45.4375C17.8233 45.5442 17.7209 45.6309 17.6028 45.6907C17.4847 45.7505 17.3542 45.7817 17.2219 45.7817C17.0895 45.7817 16.959 45.7505 16.8409 45.6907C16.7228 45.6309 16.6204 45.5442 16.5421 45.4375C13.5308 41.342 1.54102 24.5597 1.54102 16.987C1.54102 12.8282 3.1931 8.83969 6.13383 5.89896C9.07455 2.95824 13.063 1.30615 17.2219 1.30615C21.3807 1.30615 25.3692 2.95824 28.3099 5.89896C31.2506 8.83969 32.9027 12.8282 32.9027 16.987Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3652 12.8481V17.2051H21.7327",
    stroke: "#527DEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6151 41.6134C23.5725 42.2574 25.4989 43.7263 25.4989 45.4318C25.4989 47.7318 21.7419 49.5964 17.1074 49.5964C12.4728 49.5964 8.71582 47.7318 8.71582 45.4318C8.71582 43.6963 10.7814 42.2141 13.8224 41.5884",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2620_1417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.4444,
    height: 50,
    fill: "white",
    transform: "translate(0 0.451172)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteiconsSvg15);
export default __webpack_public_path__ + "static/media/Website icons SVG-15.bc9d3dae36b87281ae47bb2ad165b424.svg";
export { ForwardRef as ReactComponent };